import React, { useEffect, useRef, useState } from "react";
import { Container } from "react-bootstrap";
import "../../incidentes.css";
import "./flujoCaja/flujoCaja.css";
import Dashboard from "./flujoCaja/Dashboard";
import CargaDatos from "./flujoCaja/CargaDatos";
import Licenciamiento from "./flujoCaja/Licenciamiento";
import { AREAS } from "./flujoCaja/datosFinancieros";

// Botón de tablero externo según la vista activa; en Carga de Datos no se muestra.
const TABLEROS = {
  dashboard: {
    label: "Tablero-Cobranzas",
    url: "https://claude.ai/artifact/83doDZdEuQknnvNJhNEXTn",
  },
  licenciamiento: {
    label: "Tablero-Licenciamiento",
    url: "https://claude.ai/artifact/LnvrMR2GQ7qP5WiXrH3QWU?sk=4r2la2DkepBG87sRc3iFxQ",
  },
};

// Vistas: "dashboard", "licenciamiento" o el id de un área de AREAS (Carga de Datos).
const FlujoCaja = () => {
  const [vista, setVista] = useState("dashboard");
  const [menuAbierto, setMenuAbierto] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (!menuAbierto) return undefined;
    const cerrar = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setMenuAbierto(false);
      }
    };
    document.addEventListener("mousedown", cerrar);
    return () => document.removeEventListener("mousedown", cerrar);
  }, [menuAbierto]);

  const irA = (destino) => {
    setVista(destino);
    setMenuAbierto(false);
  };

  const areaSeleccionada = AREAS.find((a) => a.id === vista);

  const claseBoton = (activo) => `fc-menu-btn ${activo ? "fc-menu-btn--active" : ""}`;

  return (
    <Container fluid className="background-containerr">
      <div className="flujo-caja">
        <div className="fc-header">
          <h1 className="fc-header-title">Flujo de Caja</h1>
          <p className="fc-header-subtitle">Seguimiento de indicadores y resultados</p>

          <div className="menu-container">
            <button
              type="button"
              className={claseBoton(vista === "dashboard")}
              onClick={() => irA("dashboard")}
            >
              Dashboard
            </button>

            <div className="fc-dropdown" ref={dropdownRef}>
              <button
                type="button"
                className={claseBoton(Boolean(areaSeleccionada))}
                onClick={() => setMenuAbierto(!menuAbierto)}
                aria-expanded={menuAbierto}
              >
                Carga de Datos{areaSeleccionada ? `: ${areaSeleccionada.nombre}` : ""} ▼
              </button>

              {menuAbierto && (
                <div className="fc-dropdown-menu">
                  {AREAS.map((area) => (
                    <button
                      type="button"
                      key={area.id}
                      className="fc-dropdown-item"
                      onClick={() => irA(area.id)}
                    >
                      {area.nombre}
                    </button>
                  ))}
                </div>
              )}
            </div>

            <button
              type="button"
              className={claseBoton(vista === "licenciamiento")}
              onClick={() => irA("licenciamiento")}
            >
              Licenciamiento
            </button>

            {TABLEROS[vista] && (
              <a
                className="fc-menu-btn"
                href={TABLEROS[vista].url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {TABLEROS[vista].label}
              </a>
            )}
          </div>
        </div>

        {vista === "dashboard" ? (
          <Dashboard />
        ) : vista === "licenciamiento" ? (
          <Licenciamiento />
        ) : (
          <CargaDatos area={areaSeleccionada.nombre} />
        )}
      </div>
    </Container>
  );
};

export default FlujoCaja;
